import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '../../services/user/user.service';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-accessibility-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './accessibility-modal.component.html',
  styleUrls: ['./accessibility-modal.component.scss']
})
export class AccessibilityModalComponent implements OnInit {

  @Input() isDys = false;
  @Input() isBigFont = false;
  saving = false;
  savingBigFont = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userSrv: UserService,
    private authSrv: AuthService
  ) {}

  ngOnInit() {}

  toggleDys() {
    this.isDys = !this.isDys;
    document.body.classList.toggle('dys', this.isDys);
    this.saving = true;
    // L'API exige isDys dans tous les cas : on envoie toujours les deux champs
    this.userSrv.updateAccessibility({ isDys: this.isDys, isBigFont: this.isBigFont }).subscribe(() => {
      this.authSrv.storeUser();
      this.saving = false;
    });
  }

  toggleBigFont() {
    this.isBigFont = !this.isBigFont;
    document.body.classList.toggle('big-font', this.isBigFont);
    this.savingBigFont = true;
    this.userSrv.updateAccessibility({ isDys: this.isDys, isBigFont: this.isBigFont }).subscribe(() => {
      this.authSrv.storeUser();
      this.savingBigFont = false;
    });
  }
}
